// extracted by mini-css-extract-plugin
module.exports = {"search":"search-module--search--YijUJ","icon":"search-module--icon--1qHR3","input":"search-module--input--30s7D"};